import "./ChartToolbar.css";


function ChartToolbar({ chartRef, title = "chart" }) {

  // Returns the current Chart.js instance.
  const getChart = () => chartRef.current;


  // Zoom further into the chart horizontally.
  const handleZoomIn = () => {
    const chart = getChart();

    if (chart) {
      chart.zoom({ x: 1.25, y: 1 });
    }
  };


  // Zoom out horizontally.
  const handleZoomOut = () => {
    const chart = getChart();

    if (chart) {
      chart.zoom({ x: 0.8, y: 1 });
    }
  };


  // Move the visible chart area to the left.
  const handlePanLeft = () => {
    const chart = getChart();

    if (chart) {
      chart.pan({ x: 100, y: 0 });
    }
  };


  // Move the visible chart area to the right.
  const handlePanRight = () => {
    const chart = getChart();

    if (chart) {
      chart.pan({ x: -100, y: 0 });
    }
  };


  // Reset the chart back to its original zoom level and position.
  const handleReset = () => {
    const chart = getChart();

    if (chart) {
      chart.resetZoom();
    }
  };


  // Download the current chart as a PNG image.
  const handleDownload = () => {
    const chart = getChart();

    if (!chart) return;

    const link = document.createElement("a");

    // Create a filename from the chart title.
    link.download = `${title
      .toLowerCase()
      .replaceAll(" ", "-")
      .replace(/[^a-z0-9-]/g, "")}.png`;

    link.href = chart.toBase64Image("image/png", 1);
    link.click();
  };


  // Toggle fullscreen mode for the chart card.
  const handleFullscreen = async () => {
    const chart = getChart();
    const container = chart?.canvas?.closest(".chart-card");

    if (!container) return;

    try {
      if (!document.fullscreenElement) {
        await container.requestFullscreen();
      } else {
        await document.exitFullscreen();
      }
    } catch (error) {
      console.error("Unable to open chart fullscreen:", error);
    }
  };


  return (
    <div
      className="chart-toolbar"
      aria-label={`${title} chart controls`}
    >
      <button
        type="button"
        onClick={handleDownload}
        title="Download chart"
        aria-label="Download chart"
      >
        ↓
      </button>


      <button
        type="button"
        onClick={handleZoomIn}
        title="Zoom in"
        aria-label="Zoom in"
      >
        +
      </button>


      <button
        type="button"
        onClick={handleZoomOut}
        title="Zoom out"
        aria-label="Zoom out"
      >
        −
      </button>


      <span className="chart-toolbar-divider" />


      <button
        type="button"
        onClick={handlePanLeft}
        title="Pan left"
        aria-label="Pan chart left"
      >
        ←
      </button>


      <button
        type="button"
        onClick={handlePanRight}
        title="Pan right"
        aria-label="Pan chart right"
      >
        →
      </button>


      <button
        type="button"
        onClick={handleReset}
        title="Reset chart"
        aria-label="Reset chart view"
      >
        ↺
      </button>


      <button
        type="button"
        onClick={handleFullscreen}
        title="Fullscreen"
        aria-label="View chart fullscreen"
      >
        ⛶
      </button>
    </div>
  );
}


export default ChartToolbar;